import styled from 'styled-components'

import { BoxFullFill } from 'styles'

export const Wrap = styled(BoxFullFill).attrs({})`
  margin: -20px 0 0 0;
  align-items: stretch;
`

export const WrapAddJob = styled.div`
  margin: -60px 0 0 0;
`

export const ScrollToTop = styled.img`
  width: 30px;
  height: 30px;
  transform: rotate(90deg);
  cursor: pointer;
  border-radius: 50%;
  padding: 9px 8px;
  position: fixed;
  right: 15px;
  bottom: 9%;
  &:hover {
    opacity: 0.8;
  }
`
